module.exports = __webpack_public_path__ + "img/icon-clockin.db8f2026.svg";